var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { fromEntries } from '../../utils';
import { InitialPointerState } from './constants';
export function dehydrateResourceState(state) {
    if (state.error) {
        return;
    }
    return {
        data: fromEntries(Object.entries(state.data).map(function (_a) {
            var _b = __read(_a, 2), scope = _b[0], types = _b[1];
            return [
                scope,
                fromEntries(Object.entries(types).map(function (_a) {
                    var _b = __read(_a, 2), type = _b[0], ids = _b[1];
                    return [
                        type,
                        fromEntries(Object.entries(ids).map(function (_a) {
                            var _b = __read(_a, 2), id = _b[0], state = _b[1];
                            return [
                                id,
                                __assign(__assign({}, InitialPointerState), { invalidated: state.invalidated, pointer: state.pointer, value: state.value }),
                            ];
                        })),
                    ];
                })),
            ];
        })),
        tasks: {
            nextId: 1,
            pausedBy: {},
            pending: {},
            queue: {},
        },
    };
}
//# sourceMappingURL=dehydrateResourceState.js.map